// extracted by mini-css-extract-plugin
export default {"root":"BackButton_root__v3g1J","inner":"BackButton_inner__aDbae","svg":"BackButton_svg__+Xpi6"};